export default "__VITE_ASSET__f882f1d1__"